/**
 * Route param validators for dynamic URLs.
 *
 * Used by:
 * - router.js  → withValidation() to show NotFound for bad slugs
 * - App.vue    → dropdown sync (ignore invalid params so they don't
 *                overwrite selectors or trigger resetstate → "/")
 *
 * Slugs match how the app builds URLs: spaces → hyphens, lowercase
 * (e.g. "Southern California" → "southern-california",
 *        "Early January" → "early-january",
 *        "Green Beans" → "green-beans").
 */

import { listStates } from "@/components/staticFiles/stateLookup.js"
import cards from "@/components/staticFiles/sfg-38.json"
import { listmonths } from "@/components/staticFiles/months.js"

/** Display name → URL slug (same convention as toURL in imagepath.js). */
function toSlug (val) {
    return val.toString().replace(/ /g, "-").toLowerCase()
}

/** True if :state slug exists in listStates (e.g. "alabama", "washington-dc"). */
export function isValidState (slug) {
    return !!slug && listStates.some(({ desc }) => toSlug(desc) === slug)
}

/** True if :month slug exists in listmonths (e.g. "early-january"). */
export function isValidMonth (slug) {
    return !!slug && listmonths.some(({ desc }) => toSlug(desc) === slug)
}

/** True if :card slug exists in produce JSON (e.g. "mangoes", "green-beans"). */
export function isValidCard (slug) {
    return !!slug && cards.some(({ name }) => toSlug(name) === slug)
}
